import { useRef } from 'react';
import { Stage, Layer, Rect, Circle, Text, Group, Path, Image } from 'react-konva';
//import image1 from './asset/images/white-globe.svg';
import image2 from "@/asset/images/123.png"
import useImage from 'use-image';


const LionImage = () => {
    const [image] = useImage('/asset/images/white-globe.svg');
    return <Image image={image} width={30} height={30} strokeWidth={0} />;
  };

export const KonvaNode = () => {
    const stageRef = useRef(null);
  return (
    <div>
        <div height={"200px"}>
        <img src={image2} width={100} height={100} />
        </div>
        <div>
    <Stage ref={stageRef} width={window.innerWidth} height={window.innerHeight}>
      <Layer>
        <Group x={400} y={100}>
        <Rect onMouseEnter={()=>{
            stageRef.current?.container().style.cursor = 'move';
        }}  onMouseLeave={()=>{
            stageRef.current?.container().style.cursor = 'default';
        }}
         stroke={"#999"} strokeWidth={1} width={100} height={30} cornerRadius={5} fill="#7ac6cb" />
        <Text text='服务端' x={38} y={9} fontSize={14} strokeWidth={0} />

        <Group>
            <Path data={"M5 0 h25 v30 h-25 a 5 5 0 0 1 -5 -5  v-20 a 5 5 0 0 1 5 -5"} />
            <LionImage />
            <Path data={"M 29.5 1 l 0 28"} />
        </Group>
         </Group>
        <Circle x={200} y={200} stroke="black" radius={50} />
      </Layer>
    </Stage>
    </div>
    </div>
  );
}